import en from './en.json'
import it from './it.json'

export const linksTranslations = {
	en,
	it
} as const
